import { useEffect, useState } from 'react';
import styles from './styles.module.scss';

interface ToggleProps {
  onClick: (toggleValue: boolean) => void;
  isToggled: boolean;
  testIdAttribute: string;
  disabled: boolean;
}

const Toggle = (props: ToggleProps) => {
  const { isToggled = false, onClick, testIdAttribute, disabled } = props;
  const [toggled, setToggled] = useState(false);

  useEffect(() => {
    setToggled(isToggled);
  }, [isToggled]);

  return (
    <div
      onClick={() => !disabled && onClick(!toggled)}
      className={`${styles.toggleBackground} ${toggled && styles.toggledBackground} ${disabled && styles.disabled}`}
      role="switch"
      tabIndex={0}
      aria-checked={toggled}
      aria-disabled={disabled}
      data-testid={testIdAttribute}
    >
      <div className={`${styles.toggleCircle} ${toggled && styles.toggledCircle}`} />
    </div>
  );
};

export default Toggle;
